import React from 'react';

const CloseX = ({title}) => (
    <svg viewBox="0 0 18 18">
        {title && <title>{title}</title>}
        <g id="Artikel-App" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Artikel-Share" transform="translate(-342.000000, -23.000000)" stroke="#FFFFFF" strokeWidth="2">
                <g id="X" transform="translate(343.000000, 24.000000)">
                    <polyline
                        id="Path-2"
                        transform="translate(12.000000, 8.000000) scale(-1, 1) rotate(90.000000) translate(-12.000000, -8.000000) "
                        points="4 12 12 4 20 12"
                    ></polyline>
                    <polyline
                        id="Path-2-Copy-3"
                        transform="translate(4.000000, 8.000000) rotate(90.000000) translate(-4.000000, -8.000000) "
                        points="-4 12 4 4 12 12"
                    ></polyline>
                </g>
            </g>
        </g>
    </svg>
);

export default CloseX;
